(() => {
  const MQ = "(max-width: 767px)";
  const CAT_MAP = {
    sofa: "images",
    dimensions: "dimensions",
    video: "videos",
  };

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function parseSource(root) {
    const el = root.querySelector("[data-sticky-media-source]");
    if (!el) return { images: [], dimensions: [], videos: [] };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return { images: [], dimensions: [], videos: [] };
    }
  }

  function pickVideoUrl(media) {
    if (!media) return { videoUrl: "", videoType: "video/mp4" };
    const sources = Array.isArray(media.sources) ? media.sources : [];
    const mp4 = sources.find((s) => {
      const mime = s?.mime_type || "";
      const url = s?.url || "";
      return mime.includes("mp4") || /\.mp4(\?|$)/i.test(url);
    });
    const pick = mp4 || sources[0];
    return {
      videoUrl: pick?.url || media.src || "",
      videoType: pick?.mime_type || "video/mp4",
    };
  }

  function classifyMediaList(mediaList) {
    const images = [];
    const dimensions = [];
    const videos = [];

    (mediaList || []).forEach((media) => {
      if (!media) return;
      const type = media.media_type || "image";
      const alt = (media.alt || "").toLowerCase();
      const poster =
        media.preview_image?.src ||
        media.preview_image?.url ||
        media.src ||
        "";

      if (type === "video" || type === "external_video") {
        const { videoUrl, videoType } = pickVideoUrl(media);
        videos.push({
          id: media.id,
          src: poster,
          alt: media.alt || "",
          videoUrl,
          videoType,
          mediaType: type,
        });
        return;
      }

      if (type === "model") return;
      if (!poster && !media.src) return;

      const entry = {
        id: media.id,
        src: poster || media.src,
        alt: media.alt || "",
      };

      if (alt.includes("dimension")) dimensions.push(entry);
      else images.push(entry);
    });

    if (!images.length && !dimensions.length && !videos.length) return null;
    return { images, dimensions, videos };
  }

  /** Prefer current SKU media from grouping; never rewrite the main gallery. */
  function collectSkuScopedSource() {
    try {
      const grouping = window.productMediaPreGrouping;
      if (grouping?.isInitialized) {
        const current =
          (typeof grouping.getCurrentVariantMedia === "function" &&
            grouping.getCurrentVariantMedia()) ||
          grouping.currentCombination?.media ||
          null;
        const classified = classifyMediaList(current);
        if (classified) return classified;
      }
    } catch (e) {}

    // Fallback: read already-filtered slides from main gallery (read-only)
    const gallery = document.querySelector("media-gallery");
    if (!gallery) return null;

    const items = gallery.querySelectorAll(
      ".product__media-item:not(.swiper-slide-duplicate)"
    );
    if (!items.length) return null;

    const images = [];
    const dimensions = [];
    const videos = [];

    items.forEach((item) => {
      if (item.hidden || item.style.display === "none") return;
      const type = item.dataset.mediaType || "image";
      const img = item.querySelector("img");
      const poster =
        img?.currentSrc ||
        img?.src ||
        img?.getAttribute("data-src") ||
        img?.getAttribute("src") ||
        "";

      if (type === "video" || type === "external_video") {
        const videoEl = item.querySelector("video");
        let videoUrl = videoEl?.currentSrc || videoEl?.getAttribute("src") || "";
        if (!videoUrl && videoEl) {
          const sources = [...videoEl.querySelectorAll("source")];
          const mp4 = sources.find((s) => {
            const mime = s.getAttribute("type") || "";
            const src = s.getAttribute("src") || "";
            return mime.includes("mp4") || /\.mp4(\?|$)/i.test(src);
          });
          videoUrl = (mp4 || sources[0])?.getAttribute("src") || "";
        }
        if (!videoUrl) {
          const tpl = item.querySelector("template");
          const tplVideo = tpl?.content?.querySelector?.("video");
          if (tplVideo) {
            const sources = [...tplVideo.querySelectorAll("source")];
            const mp4 = sources.find((s) => {
              const mime = s.getAttribute("type") || "";
              const src = s.getAttribute("src") || "";
              return mime.includes("mp4") || /\.mp4(\?|$)/i.test(src);
            });
            videoUrl =
              tplVideo.getAttribute("src") ||
              (mp4 || sources[0])?.getAttribute("src") ||
              "";
          }
        }
        if (!poster && !videoUrl) return;
        videos.push({
          id: item.dataset.mediaId || item.dataset.target || videoUrl || poster,
          src: poster,
          alt: img?.alt || "",
          videoUrl,
          videoType: "video/mp4",
          mediaType: type,
        });
        return;
      }

      if (type === "model") return;
      if (!poster) return;

      const entry = {
        id: item.dataset.mediaId || item.dataset.target || poster,
        src: poster,
        alt: img?.alt || "",
      };
      const alt = (img?.alt || "").toLowerCase();
      if (alt.includes("dimension")) dimensions.push(entry);
      else images.push(entry);
    });

    if (!images.length && !dimensions.length && !videos.length) return null;
    return { images, dimensions, videos };
  }

  function initStickyMedia() {
    const root = document.querySelector("[data-product-mobile-sticky-media]");
    if (!root || root.__stickyMediaBound) return;
    root.__stickyMediaBound = true;

    // Smooth reveal: the sticky image stays rendered and fades in/out instead of toggling display
    const FX = "a";
    root.dataset.fx = FX;
    root.hidden = false;

    // Keep sticky completely outside product flex / media-gallery DOM tree
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    const frame = root.querySelector("[data-sticky-media-frame]");
    const photo = root.querySelector("[data-sticky-media-photo]");
    const video = root.querySelector("[data-sticky-media-video]");
    const nav = root.querySelector("[data-sticky-media-quick-nav]");
    const favBtn = root.querySelector("[data-sticky-wishlist-mount] .pdp-fav-proxy");
    const galleryWrap =
      document.querySelector("[data-main-gallery]") ||
      document.querySelector(".product__media-wrapper") ||
      document.querySelector("media-gallery");
    const cta =
      document.querySelector(".product__block--buy_buttons .product-form__submit") ||
      document.querySelector(".product-form__submit") ||
      document.querySelector(".product__block--buy_buttons");

    if (!frame || !photo || !galleryWrap || !cta) return;

    let source = collectSkuScopedSource() || parseSource(root);
    let category = "sofa";
    let index = 0;
    let storedPinH = 0;
    // Scroll-direction hide: scrolling UP fades the sticky image out, scrolling DOWN brings it back,
    // picking a colour / configuration shows it again until the next upward scroll. The close button hides it until the next pick.
    const UP_HIDE_PX = 60;
    const DOWN_SHOW_PX = 24;
    let lastScrollY = window.pageYOffset || 0;
    let upAccum = 0;
    let downAccum = 0;
    let hiddenByScroll = false;
    let dismissed = false;
    let currentVideoUrl = "";
    const mq = window.matchMedia(MQ);

    function listFor(cat) {
      const key = CAT_MAP[cat] || "images";
      return source[key] || [];
    }

    function stopVideo() {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
      video.removeAttribute("src");
      while (video.firstChild) video.removeChild(video.firstChild);
      video.load();
      video.hidden = true;
      video.setAttribute("aria-hidden", "true");
      currentVideoUrl = "";
    }

    function playMuted(item) {
      if (!video || !item?.videoUrl) {
        stopVideo();
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;
      video.controls = false;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("autoplay", "");
      video.setAttribute("loop", "");
      video.removeAttribute("controls");

      if (currentVideoUrl !== item.videoUrl) {
        currentVideoUrl = item.videoUrl;
        while (video.firstChild) video.removeChild(video.firstChild);
        video.removeAttribute("src");
        const sourceEl = document.createElement("source");
        sourceEl.src = item.videoUrl;
        sourceEl.type = item.videoType || "video/mp4";
        video.appendChild(sourceEl);
        if (item.src) video.poster = item.src;
        video.load();
      }

      video.hidden = false;
      video.setAttribute("aria-hidden", "false");

      const attempt = () => {
        video.muted = true;
        const p = video.play();
        if (p && typeof p.catch === "function") p.catch(() => {});
      };
      attempt();
      video.addEventListener("loadeddata", attempt, { once: true });
      video.addEventListener("canplay", attempt, { once: true });
    }

    function syncNavButtons() {
      if (!nav) return;
      nav.querySelectorAll("[data-sticky-media-action]").forEach((btn) => {
        const action = btn.getAttribute("data-sticky-media-action");
        const list = listFor(action);
        const show = list.length > 0;
        btn.hidden = !show;
        btn.toggleAttribute("aria-hidden", !show);

        const active = action === category;
        btn.classList.toggle("is-active", active && show);
        if (active && show) btn.setAttribute("aria-current", "true");
        else btn.removeAttribute("aria-current");
      });
    }

    // Shopify CDN: never decode the 2000px original for a 390px-wide frame
    function sized(url) {
      if (!FX || !url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url) || /[?&]width=/.test(url)) return url;
      return url + (url.includes("?") ? "&" : "?") + "width=900";
    }

    // Show the slide the visitor is looking at in the main gallery, not always the first image.
    // lastSyncedId is committed only after the active slide exists in the current SKU lists,
    // so a read that happens before the gallery DOM is ready can be retried.
    let lastSyncedId = "";
    let followGen = 0;
    function syncFromGallery() {
      const act = document.querySelector(
        "media-gallery .product__media-item.swiper-slide-active"
      );
      const id = act?.dataset?.mediaId;
      if (!id || String(id) === lastSyncedId) return;
      for (const cat of ["sofa", "dimensions", "video"]) {
        const i = listFor(cat).findIndex((m) => String(m.id) === String(id));
        if (i >= 0) {
          lastSyncedId = String(id);
          category = cat;
          index = i;
          render();
          return;
        }
      }
    }

    function render() {
      const list = listFor(category);
      if (!list.length) {
        const fallback =
          ["sofa", "dimensions", "video"].find((c) => listFor(c).length) || "sofa";
        category = fallback;
      }
      const items = listFor(category);
      if (!items.length) return;

      if (index < 0 || index >= items.length) index = 0;
      const item = items[index];
      const isVideo = category === "video";

      const nextSrc = sized(item.src);
      if (nextSrc && photo.src !== nextSrc) {
        if (FX && root.classList.contains("is-pinned")) {
          photo.classList.add("is-swapping");
          const done = () => photo.classList.remove("is-swapping");
          photo.addEventListener("load", done, { once: true });
          photo.addEventListener("error", done, { once: true });
        }
        photo.src = nextSrc;
        if (FX && typeof photo.decode === "function") photo.decode().catch(() => {});
      }
      photo.alt = item.alt || photo.alt || "";

      const canPlayVideo = isVideo && !!item.videoUrl;
      frame.classList.toggle("is-video", canPlayVideo);

      if (canPlayVideo) playMuted(item);
      else stopVideo();

      syncNavButtons();
    }

    // Same lookups the main gallery's own Image / Dimension / Video buttons use (product-info.js),
    // so each tab lands on the slide that belongs to the selected colour + configuration
    function mediaItemFor(action) {
      try {
        if (action === "sofa" && typeof findMainMediaItem === "function") return findMainMediaItem();
        if (action === "dimensions" && typeof findDimensionMediaForNav === "function") {
          const variant = typeof getCurrentVariantForMediaNav === "function" ? getCurrentVariantForMediaNav() : null;
          return findDimensionMediaForNav(variant);
        }
        if (action === "video" && typeof findVideoMediaItem === "function") return findVideoMediaItem();
      } catch (e) {}
      return null;
    }

    function setCategory(action) {
      if (!listFor(action).length) return;
      followGen++;
      category = action;
      index = 0;
      const id = mediaItemFor(action)?.dataset?.mediaId;
      if (id) {
        const i = listFor(action).findIndex((m) => String(m.id) === String(id));
        if (i >= 0) index = i;
      }
      render();
    }

    function cycle(dir) {
      const items = listFor(category);
      if (items.length < 2) return;
      followGen++;
      index = (index + dir + items.length) % items.length;
      render();
    }

    function refreshSource() {
      const live = collectSkuScopedSource();
      if (live) source = live;
      if (!listFor(category).length) {
        category =
          ["sofa", "dimensions", "video"].find((c) => listFor(c).length) || "sofa";
        index = 0;
      } else if (index >= listFor(category).length) {
        index = 0;
      }
      render();
    }

    function getPinHeight() {
      if (storedPinH) return storedPinH;
      if (root.classList.contains("is-pinned") && root.offsetHeight) {
        storedPinH = root.offsetHeight;
        return storedPinH;
      }
      const width = galleryWrap.clientWidth || window.innerWidth;
      return Math.round(width * 0.75);
    }

    function setPinned(on) {
      const pinned = root.classList.contains("is-pinned");
      if (on === pinned) return;
      root.classList.toggle("is-pinned", on);
      if (!FX) root.hidden = !on;
      root.setAttribute("aria-hidden", on ? "false" : "true");
      if (on) {
        requestAnimationFrame(() => {
          if (root.offsetHeight) storedPinH = root.offsetHeight;
          if (category === "video") {
            const item = listFor(category)[index];
            if (item) playMuted(item);
          }
        });
      } else {
        stopVideo();
      }
    }

    function updatePin() {
      if (!mq.matches) {
        setPinned(false);
        return;
      }

      // FX: line the (still hidden) sticky image up with the gallery ahead of time so it is loaded + decoded before it fades in
      if (FX && !root.classList.contains("is-pinned")) syncFromGallery();
      const galleryTop = galleryWrap.getBoundingClientRect().top;
      const ctaTop = cta.getBoundingClientRect().top;
      const pinH = getPinHeight();
      // FX: small dead-zone so the bar does not flicker on/off at the CTA boundary
      const reachedCta = ctaTop <= pinH + (FX && !root.classList.contains("is-pinned") ? 32 : 8);

      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      const dy = y - lastScrollY;
      lastScrollY = y;
      if (y > 0) {
        if (dy < 0) {
          upAccum += -dy;
          downAccum = 0;
          if (upAccum >= UP_HIDE_PX) hiddenByScroll = true;
        } else if (dy > 0) {
          downAccum += dy;
          upAccum = 0;
          if (downAccum >= DOWN_SHOW_PX) hiddenByScroll = false;
        }
      }

      const shouldPin = !reachedCta && galleryTop < 0 && !hiddenByScroll && !dismissed;
      setPinned(shouldPin);
    }

    // Visitor picked a colour / configuration: show the sticky image again (after the gallery has swapped to that variant)
    let pickTimer = 0;
    document.addEventListener(
      "change",
      (e) => {
        const el = e.target;
        if (!(el && el.matches && el.matches("input[type=radio], select") && el.closest("main"))) return;
        clearTimeout(pickTimer);
        pickTimer = setTimeout(() => {
          dismissed = false;
          hiddenByScroll = false;
          upAccum = 0;
          downAccum = 0;
          updatePin();
        }, 350);
      },
      true
    );

    const closeBtn = root.querySelector("[data-sticky-media-close]");
    if (closeBtn) {
      closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        dismissed = true;
        setPinned(false);
      });
    }

    if (nav) {
      nav.addEventListener(
        "click",
        (event) => {
          const btn = event.target.closest("[data-sticky-media-action]");
          if (!btn || !nav.contains(btn) || btn.hidden) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === "function") {
            event.stopImmediatePropagation();
          }
          setCategory(btn.getAttribute("data-sticky-media-action"));
        },
        true
      );
    }

    root.querySelectorAll("[data-sticky-media-cycle]").forEach((btn) => {
      btn.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === "function") {
            event.stopImmediatePropagation();
          }
          cycle(Number(btn.getAttribute("data-sticky-media-cycle")) || 1);
        },
        true
      );
    });

    let pointerX = 0;
    let pointerY = 0;
    let tracking = false;
    frame.addEventListener(
      "pointerdown",
      (e) => {
        if (
          e.target.closest(
            "button, a, [data-sticky-media-quick-nav], [data-sticky-wishlist-mount]"
          )
        ) {
          tracking = false;
          return;
        }
        tracking = true;
        pointerX = e.clientX;
        pointerY = e.clientY;
      },
      { passive: true }
    );
    frame.addEventListener("pointerup", (e) => {
      if (!tracking) return;
      tracking = false;
      const dx = e.clientX - pointerX;
      const dy = e.clientY - pointerY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      cycle(dx < 0 ? 1 : -1);
    });

    if (favBtn) {
      favBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const nestify = document.querySelector(".nm-PRODUCT_PAGE-wishlist-button");
        const galleryProxy = document.querySelector(
          "media-gallery [data-wishlist-mount] .pdp-fav-proxy"
        );
        if (nestify) nestify.click();
        else if (galleryProxy) galleryProxy.click();
      });

      const syncFav = () => {
        const galleryProxy = document.querySelector(
          "media-gallery [data-wishlist-mount] .pdp-fav-proxy"
        );
        const active = !!(
          galleryProxy?.classList.contains("is-active") ||
          document.querySelector(
            ".nm-PRODUCT_PAGE-wishlist-button.nm-wishlist-button--active, .nm-PRODUCT_PAGE-wishlist-button.nm-in-wishlist, .nm-PRODUCT_PAGE-wishlist-button.is-wishlisted"
          )
        );
        favBtn.classList.toggle("is-active", active);
        favBtn.setAttribute(
          "aria-label",
          active ? "Remove from wishlist" : "Add to wishlist"
        );
      };
      document.addEventListener("pdp-wishlist:changed", syncFav);
      const galleryMount = document.querySelector(
        "media-gallery [data-wishlist-mount]"
      );
      if (galleryMount && typeof MutationObserver !== "undefined") {
        new MutationObserver(syncFav).observe(galleryMount, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class", "aria-label"],
        });
      }
      syncFav();
    }

    let rafId = 0;
    const onScroll = () => {
      if (!FX) return updatePin();
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        updatePin();
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", updatePin);
    if (mq.addEventListener) mq.addEventListener("change", updatePin);
    else mq.addListener(updatePin);

    // Gallery HTML (including swiper-slide-active) is committed before `media:updated`.
    // Swiper itself is recreated on the following frame, so bind then — never on a guessed delay.
    let galleryFollowRaf = 0;
    let galleryFollowGen = 0;
    function scheduleGalleryFollow() {
      galleryFollowGen = followGen;
      if (galleryFollowRaf) return;
      galleryFollowRaf = requestAnimationFrame(() => {
        galleryFollowRaf = 0;
        if (galleryFollowGen !== followGen) return;
        ensureGalleryFollow();
        syncFromGallery();
      });
    }

    function ensureGalleryFollow() {
      const gallery = document.querySelector("media-gallery");
      if (!gallery) return;
      const slider = gallery.sliderInstance?.slider;
      if (slider && !slider.__stickyFollowBound) {
        slider.__stickyFollowBound = true;
        slider.on("slideChange", scheduleGalleryFollow);
      }
      if (gallery.__stickyFollowObserved || typeof MutationObserver === "undefined") return;
      gallery.__stickyFollowObserved = true;
      let raf = 0;
      let pendingGen = 0;
      new MutationObserver(() => {
        pendingGen = followGen;
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          if (pendingGen !== followGen) return;
          ensureGalleryFollow();
          syncFromGallery();
        });
      }).observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    function applySkuMedia() {
      const gen = followGen;
      refreshSource();
      ensureGalleryFollow();
      requestAnimationFrame(() => {
        if (gen !== followGen) return;
        ensureGalleryFollow();
        syncFromGallery();
      });
    }

    document.addEventListener("media:updated", applySkuMedia);
    document.addEventListener("productNewMediaUpdated", applySkuMedia);
    document.addEventListener("productMediaPreGroupingInitialized", applySkuMedia);

    render();
    updatePin();
    applySkuMedia();
  }

  ready(initStickyMedia);
  window.addEventListener("load", initStickyMedia);
  setTimeout(initStickyMedia, 800);
})();
